import { useState } from "react";
import { Link } from "react-router-dom";

export default function ResourceLink({ to, resourceIdentifier, resourceName }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Link
      className={`border  ${
        hovered ? "shadow-lg  border-light" : "border-white"
      }`}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        boxSizing: "border-box",
        padding: ".75rem",
        width: "100%",
        height: "100%",
        display: "inline-block",
        position: "relative",
        transition: "all .2s",
      }}
      to={to}
    >
      <div>
        <span style={{ fontWeight: "bold" }}>
          {resourceIdentifier}
          {hovered && (
            <i
              style={{ verticalAlign: "middle", fontSize: "0.9rem" }}
              className="fas fa-arrow-right ml-3"
            ></i>
          )}
        </span>
        <br />
        <span style={{ fontSize: ".9rem", color: "gray" }}>{resourceName}</span>
      </div>
    </Link>
  );
}
